import styled from 'styled-components';

export default styled.div`
  .title-three-tip-icon {
    width: 14px;
    height: 14px;
    color: #9e9e9e;
  }
  .notice-channel-box {
    width: 400px;
    .channel-box-title {
      height: 48px;
      background: #f6f6f6;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 25px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      text-align: center;
      padding: 0 ${(props) => props.theme.spacing(67 / 8)} 0
        ${(props) => props.theme.spacing(43 / 8)};
      align-items: center;
    }
    .channel-box-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: center;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      line-height: 25px;
      border-bottom: 1px solid #dddddd;
      span {
        width: 50%;
      }
    }
  }
  .member-rules {
    font-size: 14px;
    font-weight: 400;
    color: #c9c9c9;
    line-height: 50px;
    margin-left: ${(props) => props.theme.spacing(23 / 8)};
  }
`;
